import { Phone, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

export default function Contact() {
  const [sent, setSent] = useState(false);
  return (
    <div className="mx-auto grid max-w-5xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:px-8">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Contact Doctor+</h1>
        <p className="mt-3 text-slate-600">We'd love to hear from you. For medical emergencies, please dial 112.</p>
        <div className="mt-8 space-y-4 text-sm">
          <div className="flex items-center gap-3"><Phone className="h-5 w-5 text-blue-700" /> +91 1800-123-4567</div>
          <div className="flex items-center gap-3"><Mail className="h-5 w-5 text-blue-700" /> care@doctor-plus.in</div>
          <div className="flex items-center gap-3"><MapPin className="h-5 w-5 text-blue-700" /> Mumbai • Delhi • Bengaluru</div>
        </div>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); setSent(true); toast.success("Message sent"); }} className="card p-6">
        <input required className="input-field" placeholder="Your name" />
        <input required type="email" className="input-field mt-3" placeholder="Email" />
        <textarea rows={4} required className="input-field mt-3" placeholder="How can we help?" />
        <button className="btn-primary mt-4 w-full">{sent ? "Message sent" : "Send Message"}</button>
      </form>
    </div>
  );
}
